import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { usePageTitle } from 'utils/pageTitle';
import {
	fetchCurrentSubscription,
	fetchPaymentHistory,
	fetchSubscriptionHistory,
} from 'data/reducers/subscriptionReducer';

const PaymentSuccess = () => {
	const dispatch = useDispatch();
	const [sessionId, setSessionId] = useState(null);
	const history = useHistory();
	const location = useLocation();

	usePageTitle('Payment Successful - Violerts');

	useEffect(() => {
		// Extract session ID from URL parameters
		const urlParams = new URLSearchParams(location.search);
		const sessionIdParam = urlParams.get('session_id');

		if (sessionIdParam) {
			setSessionId(sessionIdParam);
		}

		// Refresh subscription data in Redux state
		dispatch(fetchCurrentSubscription());
		dispatch(fetchPaymentHistory());
		dispatch(fetchSubscriptionHistory());
	}, [location, history, dispatch]);

	const handleContinue = () => {
		history.push('/dashboard/settings');
	};

	return (
		<div
			style={{
				minHeight: '100vh',
				background: '#2c2e3e',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '20px',
			}}
		>
			<div
				style={{
					background: 'rgba(255, 255, 255, 0.05)',
					border: '1px solid rgba(255, 255, 255, 0.1)',
					borderRadius: '16px',
					padding: '48px 32px',
					maxWidth: '500px',
					width: '100%',
					textAlign: 'center',
					backdropFilter: 'blur(10px)',
				}}
			>
				{/* Success Icon */}
				<div style={{ marginBottom: '32px' }}>
					<svg
						width="80"
						height="80"
						viewBox="0 0 80 80"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						style={{ margin: '0 auto' }}
					>
						<circle cx="40" cy="40" r="40" fill="#22C55E" />
						<path
							d="M25 40L35 50L55 30"
							stroke="white"
							strokeWidth="4"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>

				{/* Success Message */}
				<h1
					style={{
						fontSize: '2.5rem',
						fontWeight: '700',
						color: '#22C55E',
						marginBottom: '16px',
						fontFamily:
							'-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
					}}
				>
					Payment Successful!
				</h1>

				<p
					style={{
						fontSize: '1.1rem',
						color: '#A0A3B1',
						lineHeight: '1.6',
						marginBottom: '32px',
					}}
				>
					Thank you for subscribing to Violerts! Your payment has been processed
					successfully.
				</p>

				{sessionId && (
					<p
						style={{
							fontSize: '0.9rem',
							color: '#6B7280',
							marginBottom: '32px',
							fontFamily: 'monospace',
							background: 'rgba(255, 255, 255, 0.05)',
							padding: '12px',
							borderRadius: '8px',
							wordBreak: 'break-all',
						}}
					>
						Session ID: {sessionId}
					</p>
				)}

				<div
					style={{
						marginBottom: '24px',
						textAlign: 'left',
						background: 'rgba(34, 197, 94, 0.1)',
						border: '1px solid rgba(34, 197, 94, 0.3)',
						borderRadius: '8px',
						padding: '20px',
					}}
				>
					<h3
						style={{
							color: 'white',
							fontSize: '1.1rem',
							fontWeight: '600',
							marginBottom: '16px',
						}}
					>
						What's Next?
					</h3>
					<ul
						style={{
							color: '#A0A3B1',
							fontSize: '0.95rem',
							lineHeight: '1.6',
							margin: 0,
							paddingLeft: '20px',
						}}
					>
						<li>You'll receive a confirmation email shortly</li>
						<li>Your account has been upgraded with your selected plan</li>
						<li>You can now access all premium features</li>
						<li>Visit your dashboard to get started</li>
					</ul>
				</div>

				{/* Action Buttons */}
				<div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
					<button
						onClick={handleContinue}
						style={{
							background: '#22C55E',
							border: 'none',
							borderRadius: '8px',
							color: 'white',
							padding: '14px 28px',
							fontSize: '1rem',
							fontWeight: '600',
							cursor: 'pointer',
							transition: 'all 0.3s ease',
						}}
						onMouseOver={(e) => (e.target.style.background = '#16A34A')}
						onMouseOut={(e) => (e.target.style.background = '#22C55E')}
					>
						Go to Dashboard
					</button>

					<button
						onClick={() => history.push('/')}
						style={{
							background: 'transparent',
							border: '1px solid rgba(255, 255, 255, 0.3)',
							borderRadius: '8px',
							color: 'white',
							padding: '14px 28px',
							fontSize: '1rem',
							fontWeight: '600',
							cursor: 'pointer',
							transition: 'all 0.3s ease',
						}}
						onMouseOver={(e) => {
							e.target.style.background = 'rgba(255, 255, 255, 0.1)';
							e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
						}}
						onMouseOut={(e) => {
							e.target.style.background = 'transparent';
							e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
						}}
					>
						Back to Home
					</button>
				</div>

				{/* Support Link */}
				<p
					style={{
						fontSize: '0.9rem',
						color: '#6B7280',
						marginTop: '32px',
					}}
				>
					Need help?{' '}
					<a
						href="mailto:admin@violerts.com"
						style={{
							color: '#22C55E',
							textDecoration: 'none',
						}}
					>
						Contact Support
					</a>
				</p>
			</div>
		</div>
	);
};

export default PaymentSuccess;
